const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
/*
  @param Object newState "Objeto con modificaciones a remplezar el objeto state"
*/
const setState = (newState, executed = true) => {
  state = { ...state, ...newState };
  if (!executed) {
    return;
  }
  subscriptions.map((subscription) => {
    const nodeSets = subscription.elements.map((el) =>
      subscription.all ? $$(el) : [$(el)]
    );
    nodeSets.forEach((nodeSet) => {
      if (nodeSet) {
        nodeSet.forEach((node) => {
          switch (subscription.type) {
            case "innerHtml":
              node.innerHTML = state.displayed[subscription.property];
              break;
            case "innerText":
              node.innerText = state.displayed[subscription.property];
              break;
            case "setAttribute":
              node.setAttribute(
                subscription.attribute,
                state.displayed[subscription.property]
              );
              break;
            case "toggle":
              if (state.displayed[subscription.property] == "") {
                node.classList.remove(subscription.attribute);
              }
              if (state.displayed[subscription.property] != "") {
                node.classList.add(subscription.attribute);
              }
              break;
            case "img":
              node.src = state.displayed[subscription.property];
              node.setAttribute(
                "data-src",
                state.displayed[subscription.property]
              );
            default:
              node.innerText = state.displayed[subscription.property];
              break;
          }
        });
      }
    });
  });
};
/*Size Option*/
const onClickSizeOption = (index, size) => {
  $(`[data-options-error-${index}]`).classList.add("is-hidden");
  /*Actualiza la opcion seleccionada*/
  setState(
    {
      ...state,
      selection: {
        ...state.selection,
        [index]: size,
      },
    },
    false
  );
  /*Actualiza la url*/
  changeUrlVariantId();
  /*Actualiza el contenido HTML*/
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      price: state.subscription
        ? state.product.subscription.price_money
        : state.product.price_money,
      compare_at_price: state.subscription
        ? state.product.subscription.compare_at_price_money
        : state.product.compare_at_price_money,
      price_subscription: state.product.subscription.price_money,
      price_one_time: state.product.price_money,
    },
  });
};
const onClickColorOption = (index, size) => {
  /*Actualiza la opcion seleccionada*/
  setState(
    {
      ...state,
      selection: {
        ...state.selection,
        [index]: size,
      },
    },
    false
  );
  let variantFilter = state.variants.find((variant) => {
    const parts = variant.title.split("/").map((v) => v.trim());
    return parts[index] == state.selection[index];
  });
  $(`[data-options-error-${index}]`).classList.add("is-hidden");
  /*Actualiza la url*/
  changeUrlVariantId();
  /*Actualiza el contenido HTML*/
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      price: state.subscription
        ? state.product.subscription.price_money
        : state.product.price_money,
      compare_at_price: state.subscription
        ? state.product.subscription.compare_at_price_money
        : state.product.compare_at_price_money,
      price_subscription: state.product.subscription.price_money,
      price_one_time: state.product.price_money,
      first_media: state.subscription
        ? variantFilter.subscription.src
        : variantFilter.one_time.src,
      first_media_thumb: state.subscription
        ? variantFilter.subscription.src_50
        : variantFilter.one_time.src_50,
    },
  });
};
/*Subscription*/
const onClickSubscription = (type) => {
  setState({
    ...state,
    subscription: type == "subscription" ? true : false,
  });
  /*Actualiza la url*/
  changeUrlVariantId();
  /*Actualiza el contenido HTML*/
  setState({
    ...state,
    displayed: {
      ...state.displayed,
      price: state.subscription
        ? state.product.subscription.price_money
        : state.product.price_money,
      compare_at_price: state.subscription
        ? state.product.subscription.compare_at_price_money
        : state.product.compare_at_price_money,
      kit_description: state.subscription
        ? state.product.subscription.kit_description
        : state.product.kit_description,
      variant_id: state.product.subscription.id,
      variant_subscription_id: state.product.subscription.id,
      variant_one_time_id: state.product.id,
      first_media: state.subscription
        ? variantFilter.subscription.src
        : variantFilter.one_time.src,
      first_media_thumb: state.subscription
        ? variantFilter.subscription.src_50
        : variantFilter.one_time.src_50,
    },
  });
};
/*Submit Float*/
const onSubmitFloat = () => {
  const swatch = $(".content_prices");
  swatch.scrollIntoView({ behavior: "smooth", block: "start" });
  onSubmit();
};
/*Submit*/
const onSubmit = () => {
  /* Validacion Submit */
  allInputChecked = true;
  Object.values(state.selection).map((textOption, index) => {
    let notExistChecked = true;
    $$(`[name="swatch_size_input_${index}"]`).forEach((option) => {
      if (option.checked) {
        notExistChecked = false;
      }
    });
    const pElementError = $(`[data-options-error-${index}]`);
    if (notExistChecked && pElementError) {
      allInputChecked = false;
      pElementError.classList.remove("is-hidden");
      pElementError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return { notExistChecked, pElementError, index };
  });
  if (!allInputChecked) {
    return;
  }
  const variantFilter = getVariantSelected();
  const variantId = state.subscription
    ? variantFilter.subscription.id
    : variantFilter.one_time.id;
  const purchaseType = state.subscription ? "subscription_product" : "one-time";
  const inputDiscount = $("[data-discount-form]");
  const discountValue =
    inputDiscount && inputDiscount.name != "" ? inputDiscount.value : undefined;
  const productParams = {
    id: variantId,
    quantity: valueInput.value,
    properties: { _purchase_type: purchaseType },
    ...(discountValue && { "attributes[discount]": discountValue }),
    ...(state.subscription && { selling_plan: state.selling_plan }),
  };
  items = [productParams];
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items,
    }),
  })
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error.message);
    });
};
/*
  Retorna la variante seleccionada filtrada por la seleccion dentro de state.selection
*/
const getVariantSelected = (kitName = undefined) => {
  let variantFilter = state.variants.find((variant) => {
    const parts = variant.title.split("/").map((v) => v.trim());
    return Object.keys(state.selection).every(
      (index) => parts[index] == state.selection[index]
    );
  });
  return variantFilter;
};
/*Url Update*/
const changeUrlVariantId = () => {
  variantFilter = getVariantSelected();
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("variant")) {
    urlParams.set("variant", variantFilter.one_time.id);
  } else {
    urlParams.append("variant", variantFilter.one_time.id);
  }
  const url = `${window.location.protocol}//${window.location.host}${
    window.location.pathname
  }?${urlParams.toString()}`;
  window.history.replaceState({}, "", url);
};

const productSection = $(".product_buttons__submit");
const floatCta = $(".float_btn_container");
/*CTA Float*/
const handleScroll = () => {
  const rect = productSection.getBoundingClientRect();
  const isVisible = rect.top >= 0;
  const wizybotElement = $("div#wizydiv iframe");
  const klaviyoPopPup = $(".needsclick");
  let distanceWizy = "10px";
  if (window.innerWidth <= 1023) {
    if (!isVisible) {
      let distanceWizy = "70px";
      floatCta.classList.remove('is-hidden');
      wizybotElement ? wizybotElement.style.bottom = distanceWizy : undefined;
      klaviyoPopPup ? klaviyoPopPup.style.bottom = distanceWizy : undefined;
    } else {
      floatCta.classList.add('is-hidden');
      wizybotElement ? wizybotElement.style.bottom = distanceWizy : undefined;
      klaviyoPopPup ? klaviyoPopPup.style.bottom = distanceWizy : undefined;
    }
  }
}
const handleValidateRecurrentProduct = (variantId) => {
  let resultValidation = true;
  const existInRecurrent = variantsRecurrentProduct.find(
    (item) => item.variant_id == variantId
  );
  let existInCart = undefined;
  if (window?.Rebuy?.SmartCart?.items()) {
    existInCart = window.Rebuy.SmartCart.items().find((itemCart) =>
      variantsRecurrentProduct.find(
        (itemVariant) => itemVariant.id == itemCart.id
      )
    );
  } else {
    existInCart = variantsCart.find((itemCart) =>
      variantsRecurrentProduct.find(
        (itemVariant) => itemVariant.id == itemCart.id
      )
    );
  }
  if (existInRecurrent && existInCart) {
    resultValidation = false;
  }
  return resultValidation;
};
const closeModalSize = (index) => {
  $(`#sizes-modal-${index}`).classList.toggle("is-hidden");
  $(`#sizes-modal-overlay-${index}`).classList.toggle("is-hidden");
};
const handleModalSizeGuide = (index) => {
  $(`#sizes-modal-${index}`).classList.toggle("is-hidden");
  $(`#sizes-modal-overlay-${index}`).classList.toggle("is-hidden");
};
const videosModal = $(".product-sw__modal-videos");
const videosModalWrapper = videosModal.querySelector(".swiper-wrapper");
const handleClickShowVideosGallery = (indexVideo) => {
  const realIndex = indexVideo - 1;
  videosModal.classList.add("is-active");
  videosSlider.update();
  videosSlider.slideTo(realIndex);
};
const closeShowModalVideos = () => {
  videosModal.classList.remove("is-active");
  videosModalWrapper.querySelectorAll(".video-slide").forEach((video) => {
    video.muted = true;
  });
};
const handleOnSoundVideo = (event) => {
  const containers = $$(
    ".product-sw__modal-videos__slider .product-sw__modal-videos__slider__slide"
  );
  const currentContainer = event.target.closest(
    ".product-sw__modal-videos__slider__slide"
  );
  const currentVideo = currentContainer.querySelector("video");
  const currentBtn = currentContainer.querySelector("button");
  containers.forEach((container) => {
    const video = container.querySelector("video");
    const btn = container.querySelector("button");
    if (video !== currentVideo) {
      btn.classList.add("muted");
      video.muted = true;
    }
  });
  currentBtn.classList.toggle("muted");
  currentVideo.muted = !currentVideo.muted;
};
const valueInput = document.getElementById("quantitySelectorValue");
const valueNumber = document.getElementById("valueNumber");
const btnMinus    = document.getElementById("btnMinus");
const btnMore     = document.getElementById("btnMore");

// Función que habilita/deshabilita el botón “–”
function updateButtons() {
  const v = +valueInput.value;
  btnMinus.disabled = v <= 1;
};

function btnMinusQuantityComp() {
  let v = +valueInput.value - 1;
  if (v < 1) v = 1;
  valueInput.value  = v;
  valueNumber.textContent = v;
  updateButtons();
};

function btnMoreQuantityComp() {
  const v = +valueInput.value + 1;
  valueInput.value  = v;
  valueNumber.textContent = v;
  updateButtons();
};

window.addEventListener("DOMContentLoaded", updateButtons);


let sliderThumbs;
let sliderMedia;
let videosSlider;

document.addEventListener("DOMContentLoaded", () => {
  /*Swiper Gallery*/
  const thumbs = $(".product_media__slider_thumbs");
  const swiperConfigThumbs = {
    breakpoints: {
      320: {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 10,
      },
      1023: {
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 10,
      },
    },
    a11y: {
      slideRole: "none",
    },
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: false,
  };

  sliderThumbs = thumbs ? new Swiper(thumbs, swiperConfigThumbs) : undefined;
  let swiperConfig = {
    // loop: true,
    a11y: {
      slideRole: "none",
    },
    navigation: {
      nextEl: ".product-gallery__navigation .swiper-button-next",
      prevEl: ".product-gallery__navigation .swiper-button-prev",
    },
  };
  if (sliderThumbs) {
    swiperConfig.thumbs = { swiper: sliderThumbs };
  }
  sliderMedia = new Swiper(".product_media__slider", swiperConfig);
  /*End Swiper*/
  handleScroll();
  window.addEventListener("scroll", () => {
    handleScroll();
  });
  new Swiper(".product-sw__info__videos-gallery", {
    slidesPerView: "3",
    spaceBetween: 15,
    breakpoints: {
      320: {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 10,
      },
      1023: {
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 10,
      },
    },
  });
  videosSlider = new Swiper(".product-sw__modal-videos__slider", {
    slidesPerView: 1,
    direction: "vertical",
    navigation: {
      nextEl: ".product-sw__modal-videos__slider .swiper-button-next",
      prevEl: ".product-sw__modal-videos__slider .swiper-button-prev",
    },
  });
  videosSlider.on("slideChange", function (e) {
    const slider = e.el;
    const slides = slider.querySelectorAll(
      ".product-sw__modal-videos__slider__slide"
    );
    slides.forEach((slide, index) => {
      slide.classList.add("muted");
      slide.querySelector(".video-slide").muted = true;
      slide.querySelector("button").classList.add("muted");
    });
  });
});
